"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryStickyHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var type_guard_1 = require("@webnuts/type-guard");
var react_1 = __importDefault(require("react"));
// eslint-disable-next-line no-restricted-imports
var styled_components_1 = __importStar(require("styled-components"));
var css_types_1 = require("../../internal/css-types");
var factory_1 = require("../../internal/factory");
var factory_utils_1 = require("../../internal/factory-utils");
var SETTINGS = {
    height: type_guard_1.optional(css_types_1.measureUnit),
    boxShadow: type_guard_1.optional(css_types_1.boxShadow),
    background: type_guard_1.optional(css_types_1.background),
    bottomMargin: type_guard_1.optional(css_types_1.measureUnit),
    sticky: type_guard_1.optional(type_guard_1.boolean())
};
/**
 * As the Header and StickyHeader is really different in the implementation and
 * the way they act, they have been implemented as separate factories to avoid
 * letting the users think they can swap the implementations without issues.
 */
exports.FactoryStickyHeader = factory_1.factory({
    prefix: 'StickyHeader',
    settings: __assign(__assign({}, SETTINGS), { breakpoints: factory_utils_1.makeBreakpointSettings(SETTINGS) }),
    component: function (settings, utils) {
        var Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      box-sizing: border-box;\n      width: 100%;\n      position: relative;\n\n      ", "\n    "], ["\n      box-sizing: border-box;\n      width: 100%;\n      position: relative;\n\n      ", "\n    "])), function (_a) {
            var $settings = _a.$settings;
            return utils.css.breakpoint($settings.breakpoints, $settings, function (_a) {
                var bottomMargin = _a.bottomMargin, height = _a.height;
                return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            ", ";\n            ", "\n          "], ["\n            ", ";\n            ", "\n          "])), utils.css.rule('margin-top', height), utils.css.rule('padding-bottom', bottomMargin));
            });
        });
        var StyledHeader = styled_components_1.default.header(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      box-sizing: border-box;\n      top: ", "px;\n      left: 0;\n      position: fixed;\n      width: 100%;\n      display: flex;\n      align-items: center;\n\n      ", "\n    "], ["\n      box-sizing: border-box;\n      top: ", "px;\n      left: 0;\n      position: fixed;\n      width: 100%;\n      display: flex;\n      align-items: center;\n\n      ", "\n    "])), function (_a) {
            var $top = _a.$top, sticky = _a.$settings.sticky;
            return (sticky === true ? 0 : $top);
        }, function (_a) {
            var $settings = _a.$settings, isHidden = _a.isHidden;
            return utils.css.breakpoint($settings.breakpoints, $settings, function (_a) {
                var height = _a.height, boxShadow = _a.boxShadow, background = _a.background, bottomMargin = _a.bottomMargin, sticky = _a.sticky;
                return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "])), utils.css.height(height), utils.css.boxShadow(
                // If we're sticky, try to force a shadow. Fallback to check on isHidden.
                sticky === true ? boxShadow !== null && boxShadow !== void 0 ? boxShadow : $settings.boxShadow : isHidden ? '0 0' : boxShadow), utils.css.background(background), utils.css.rule('margin-bottom', bottomMargin), utils.css.rule('top', sticky === true ? '0px' : undefined));
            });
        });
        return react_1.default.forwardRef(function (_a, ref) {
            var _b, _c;
            var children = _a.children, props = __rest(_a, ["children"]);
            // Wrap the outer ref to get the height of the header in pixels.
            var headerRef = react_1.default.useRef(ref);
            var height = headerRef.current != null && headerRef.current.clientHeight > 0
                ? headerRef.current.clientHeight
                : (_c = undefined !== null && undefined !== void 0 ? undefined : (settings.height != null ? parseInt((_b = settings.height) === null || _b === void 0 ? void 0 : _b.replace('px', ''), 10) : undefined)) !== null && _c !== void 0 ? _c : 0;
            // Attach scroll handlers on the window, to determine if we're scrolling
            // up or down. This changes the hidden state.
            var scrollYRef = react_1.default.useRef(window.scrollY);
            var _d = __read(react_1.default.useState(0), 2), top = _d[0], setTop = _d[1];
            react_1.default.useEffect(function () {
                var scrollHandler = function () {
                    // Determine the delta, and apply it to the top value, within the
                    // boundaries.
                    var delta = window.scrollY - scrollYRef.current;
                    scrollYRef.current = window.scrollY;
                    // Determine the new top within the negative height and zero.
                    setTop(function (old) { return Math.min(0, Math.max(-height, old - delta)); });
                };
                window.addEventListener('scroll', scrollHandler, { passive: true });
                return function () {
                    window.removeEventListener('scroll', scrollHandler);
                };
            }, [height, scrollYRef, setTop]);
            // We're hidden if the negative top matches the height of the header.
            var isHidden = react_1.default.useMemo(function () { return height > 0 && -top >= height; }, [top, height]);
            return (jsx_runtime_1.jsx(Container, __assign({ "$settings": settings }, { children: jsx_runtime_1.jsx(StyledHeader, __assign({ "$settings": settings, "$top": top, isHidden: isHidden, ref: headerRef }, props, { children: children }), void 0) }), void 0));
        });
    }
}).FactoryStickyHeader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
